import styled from "@emotion/styled";

export const StyledHorizontalTabs = styled.div({
  width: "100%",
  display: "flex",
  flexDirection: "column",
});

export const StyledHorizontalTabsNew = styled.div({
  width: "100%",
  display: "flex",
  backgroundColor: "#ffffff",
  boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.2)",
  flexDirection: "column",
  borderTopLeftRadius: "10px",
  borderTopRightRadius: "10px",
  "@media screen and (max-width:999px)": {
    width: "auto",
    padding: "15px",
  },
});

export const StyledTabsList = styled.ul({
  listStyleType: "none",
  margin: 0,
  padding: 0,
  display: "flex",
  flexDirection: "row",
  fontWeight: 500,
  gap: "12px",
  // "@media screen and (min-width:992px) and (max-width:1220px)": {
  //   gap: "3vw",
  // },
  "@media screen and (max-width:991px)": {
    flexDirection: "column",
    gap: "0",
  },
});

export const StyledTab = styled.li(
  {
    cursor: "pointer",
    textAlign: "center",
    padding: "8px 25px",
    display: "flex",
    alignItems: "center",
    gap: "5px",
    marginBottom: "15px",
    justifyContent: "center",
    "@media screen and (min-width:640px) and (max-width:991px)": {
      width: "auto",
    },
    "@media screen and (min-width:992px) and (max-width:1300px)": {
      padding: "10px",
      marginLeft: 0,
      justifyContent: "center",
      marginBottom: "0px",
           },
    "@media screen and (min-width:1800px)": {
      padding: "8px 50px",
    },
  },
  ({ active, backgroundColor, color, borderBottom, borderRadius }) => ({
    color: color || (active ? "#6860EE" : "var(--sidepopup-label-color)"),
    // backgroundColor: backgroundColor || (active ? "#6860ee" : "var(--tab__background)"),
    borderBottom: borderBottom || (active? "4px solid #6860ee" : "none"),
    borderRadius: borderRadius || "8px",
    display: "flex",
    gap: "5px",
    padding: "8px 25px",
  })
);

export const StyledTabMessage = styled.li(
  {
    cursor: "pointer",
    textAlign: "center",
    padding: "0px 5px",
    "@media screen and (max-width:768px)": {
      padding: "5px",
      marginLeft: 0,
    },
  },
  ({ active }) => ({
    color: active ? "#000000" : "#b1bfce",
  })
);

export const StyledMessage = styled.div(
  {
    display: "flex",
    flexDirection: "row",
    marginLeft: "30px",
    borderBottom: "5px solid #f0d90c",
  },
  ({ active }) => ({
    borderBottom: active ? "5px solid #f0d90c" : "none",
    color: active ? "#000000" : "#b1bfce",
  })
);
